import { FormTemplate } from '@nrwl/rx-models';
import { SearchType } from '../search/search.type';

export class FormCategory {
  public id: number;
  public name: string;
  public parent: number;
  public is_deleted: boolean;
  public is_pne: boolean;
  public is_stock: [boolean, string];
  public author: number;
  public expanded: boolean;
  public forms_count: number;
  public _selected = false;
  public files: any;
  public order: number;
  public position_after?: number;
  public stock_forms_count: number;
  public account_forms_count: number;
  public form_templates?: FormTemplate[];
  public _isExpanded: any;

  constructor(data: any = {}) {
    this.id = data.id || void 0;
    this.author = data.authors || void 0;
    this.name = data.name || '';
    this.is_deleted = data.is_deleted || false;
    this.is_stock = data.is_stock || void 0;
    this.expanded = false;
    this.forms_count = data.forms_count ?? void 0;
    this.order = data.order >= 0 ? data.order : void 0;
    this.position_after = data.position_after || void 0;
    this.stock_forms_count = data.stock_forms_count ?? void 0;
    this.account_forms_count = data.account_forms_count ?? void 0;
    this.is_pne = data.is_pne ?? false;
  }

  public ofType = (type: SearchType) => {
    const stock = this.is_stock[0] === true;
    const deleted = this.is_deleted === true;

    switch (type) {
      case SearchType.GlobalLibrary:
        return stock && !deleted;
      case SearchType.GlobalLibraryArchive:
        return stock && deleted === true;
      case SearchType.AccountLibrary:
        return stock === false && !deleted;
      case SearchType.AccountLibraryArchive:
        return stock === false && deleted === true;
    }
    return false;
  };

  public getType = (): any => {
    const stock = this.is_stock[0] === true;
    const deleted = this.is_deleted === true;

    if (stock && !deleted) {
      return SearchType.GlobalLibrary;
    }
    if (stock && deleted) {
      return SearchType.GlobalLibraryArchive;
    }
    if (stock === false && !deleted) {
      return SearchType.AccountLibrary;
    }
    if (stock === false && deleted) {
      return SearchType.AccountLibraryArchive;
    }
    return;
  };
}
